import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { EnhancedFileUploadArea } from './FileUpload';
import { useOCRProcessing } from '../hooks';
import { NomineeEntryForm } from './Forms';
import { OCRFailureModal } from './Modals';
import { getAge } from '../../../../v2/Utils/AgeCalc';

const InlineNomineeForm = ({ 
    staffData, 
    onSave, 
    onCancel,
    relations = []
}) => {
    const [currentStep, setCurrentStep] = useState('upload');
    const [ocrFailureModalOpen, setOcrFailureModalOpen] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [relation, setRelation] = useState('');

    useEffect(() => {
        if (relations && relations.length > 0 && !relation) {
            setRelation(relations[0].value);
        }
    }, [relations, relation]);

    const {
        isLoading,
        error,
        extractedData,
        uploadedFile,
        handleFileUpload,
        resetOCR
    } = useOCRProcessing({
        consent: 'Y'
    });

    const handleFileUploadWithOCRHandling = async (file) => {
        const success = await handleFileUpload(file);
        if (!success) {
            setOcrFailureModalOpen(true);
        }
    };

    const handleTryAgain = () => {
        setOcrFailureModalOpen(false);
        setCurrentStep('upload');
    };

    const handleEnterManually = () => {
        setOcrFailureModalOpen(false);
        setCurrentStep('manual');
    };

    const handleConfirmExtractedData = () => {
        const calculatedAge = extractedData.dob ? getAge(extractedData.dob) : null;
        const nomineeData = {
            ...extractedData,
            phone_number: phoneNumber,
            relation: relation,
            staff_no: staffData.staff_no,
            age: calculatedAge,
            ocr_verified: currentStep === 'upload' ? true : false
        };
        onSave(nomineeData);
    };

    return (
        <Box>
            <Typography variant="h2" sx={{ mb: 1 }}>
                Add Nominee Details
            </Typography>

            {currentStep === 'upload' && (
                <EnhancedFileUploadArea
                    onFileUpload={handleFileUploadWithOCRHandling}
                    isLoading={isLoading}
                    error={error}
                    uploadedFile={uploadedFile}
                    extractedData={extractedData}
                    phoneNumber={phoneNumber}
                    onPhoneChange={setPhoneNumber}
                    relation={relation}
                    onRelationChange={setRelation}
                    relations={relations}
                    onConfirm={handleConfirmExtractedData}
                    uploadTitle="Upload Nominee Aadhar"
                    processingText="Processing Nominee Aadhar..."
                    onFileDelete={() => {
                        resetOCR();
                    }}
                />
            )}

            {currentStep === 'manual' && (
                <NomineeEntryForm
                    staffData={staffData}
                    onSave={onSave}
                    initialData={{}}
                />
            )}

            <OCRFailureModal
                open={ocrFailureModalOpen}
                onClose={() => {
                    setOcrFailureModalOpen(false);
                    resetOCR();
                }}
                onTryAgain={handleTryAgain}
                onEnterManually={handleEnterManually}
                errorMessage={error}
            />
        </Box>
    );
};

export default InlineNomineeForm;